import API from '@/js/API'
window.API = API;

//引入axios
import '@/js/lib/request'


//引用es6语法插件
// import "babel-polyfill";

Vue.prototype.$message = ELEMENT.Message;
Vue.prototype.$MessageBox = ELEMENT.MessageBox;

import defaultImage from '@/images/no-image.gif'
Vue.prototype.defaultImage = defaultImage

Vue.prototype.$ = window.Jq = $;

//引入i18n国际化插件
import { i18n } from '@/locales/index';
window.i18n = i18n;

//引入swiper
import AwesomeSwiper from 'vue-awesome-swiper'
window.AwesomeSwiper = AwesomeSwiper;
Vue.use(AwesomeSwiper);


//引入懒加载
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/optimumx/ls.optimumx';
import 'lazysizes/plugins/attrchange/ls.attrchange';
window.lazySizesConfig = lazySizes.cfg || {};
window.lazySizesConfig.constrainPixelDensity = true;

//引入社交分享
var SocialSharing = require('vue-social-sharing');
window.Vue.use(SocialSharing);




// 引入规范css
import 'normalize.css/normalize.css'


//引入vuex
import store from "./store/index.js"
window.store = store;

Vue.component('v-app',require('@/js/App.vue').default);
//公共组件
Vue.component('v-back-top', require('@/js/components/BackTop.vue').default)
Vue.component('v-commoditylistitem',require('./components/common/commoditylistitem.vue').default);
Vue.component('v-contactpage',require('./components/common/contactpage.vue').default);
Vue.component('v-commoditylistitemcard',require('./components/common/commoditylistitemcard.vue').default);
Vue.component('v-commonfoot',require('./components/common/commonfoot.vue').default);
Vue.component('v-headtitle',require('./components/common/headtitle.vue').default);
Vue.component('v-line',require('./components/common/line.vue').default);
Vue.component('v-selectprice', require('./components/common/selectprice.vue').default);
Vue.component('v-noproduct',require('./components/common/noproduct.vue').default);
Vue.component('v-saveprice',require('./components/common/saveprice.vue').default);
Vue.component('v-toptitle',require('./components/common/toptitle.vue').default);
Vue.component('v-subscribe',require('./components/common/subscribe.vue').default);
// Vue.component('v-countdown',require('./components/common/countdown.vue').default);
Vue.component('v-mark',require('./components/view/mark/index.vue').default);
Vue.component('v-image-card',require('./components/view/mark/card.vue').default);
//登录页面
Vue.component('v-login',require('./components/page/login.vue').default);
Vue.component('v-register',require('./components/page/register.vue').default);
//首页
Vue.component('v-indexswiper',require('./components/view/index/indexswiper.vue').default);
Vue.component('v-indexswiperbtnbox',require('./components/view/index/indexswiperbtnbox.vue').default);

//最近售卖弹窗
Vue.component('v-lastsales',require('./components/view/lastsales/lastsales.vue').default);

// 隐私政策
Vue.component('v-privacy-policy',require('./components/view/privacyPolicy/index.vue').default);

//多语言切换
Vue.component('v-selectlang', require('./components/common/selectlang.vue').default)

//个人中心页面
Vue.component('v-accountbody',require('./components/view/account/accountbody.vue').default);
Vue.component('v-accountbodyaddress',require('./components/view/account/accountbodyaddress.vue').default);
Vue.component('v-accountbodyorder',require('./components/view/account/accountbodyorder.vue').default);
Vue.component('v-addressfrom',require('./components/view/account/addressfrom.vue').default);
Vue.component('v-accounttop',require('./components/view/account/accounttop.vue').default);
//搜索页面
Vue.component('v-search',require('./components/page/search.vue').default);
//购物车页面
Vue.component('v-cart',require('./components/page/cart.vue').default);
//商品列表页面
Vue.component('v-collections',require('./components/view/collections/collections.vue').default);
Vue.component('v-collectionitem',require('./components/view/collections/collectionitem.vue').default);
//商品详情页
Vue.component('v-product',require('./components/page/Product.vue').default);
// Vue.component('v-product',require('./views/Product/index.vue').default);
Vue.component('v-comments',require('./components/view/comments/comments.vue').default);
Vue.component('v-comments-item-box',require('./components/view/comments/commentsItemBox.vue').default);
// Vue.component('v-comments-star',require('./components/view/comments/commentsstar.vue').default);
// 自定义按钮
Vue.component('v-custom-button',require('./components/view/customButton/index.vue').default);
//error 404
Vue.component('v-error404',require('./components/page/error404.vue').default);
// 货币符号
Vue.component('v-currencysymbol',require('./components/common/currencysymbol.vue').default);
// 支付图标
Vue.component('v-payicon',require('./components/common/payicon.vue').default);

// Vue.component("v-codedisplay",require("./components/view/codedisplay/index.vue").default);
// Vue.component('v-social-auth',require('./components/view/socialauth/index.vue').default);
// 翻译
Vue.component('v-translate', require('./components/common/translate.vue').default);
//调色板
// Vue.component('v-product-palette',require('./components/view/productpalette/index.vue').default);
// 物流
Vue.component("v-track",require("./components/view/track/index.vue").default);
// 购物车备注
// Vue.component('v-cartnote',require('./components/common/cartnote.vue').default);
// dmca举报页面
Vue.component('v-dmcaform',require('./components/page/dmca_form.vue').default);
// productFilter
Vue.component('v-productFilter',require('./components/view/productFilter/index.vue').default);
// popBox
// Vue.component('v-popbox',require('./components/common/popBox.vue').default);
// 图片卡
Vue.component('v-lazy-img', require('@/js/components/LazyImg.vue').default);


//数量框

Vue.component('v-inputnum', require('@/views/venue/js/common/inputnum.vue').default);


// 图片卡
// Vue.component('v-guess-like',require('./components/view/guesslike/guesslike.vue').default);
// 空组件
Vue.component('v-empty-component',require('../js/components/common/EmptyComponent.vue').default);
// 产品tag
// Vue.component('v-product-tag',require('../js/components/view/productTag/productTag.vue').default);
// 浏览记录
Vue.component('v-browsing-record',require('./components/view/browsingRecord/browsingRecord.vue').default);

// 首页博客模块
Vue.component('v-module-blog',require('@/js/views/Home/Modules/Blog.vue').default);
// 博客页面
Vue.component('v-blog',require('@/js/views/Blog/index.vue').default);
// 博客详情页
Vue.component('v-blog-detail',require('@/js/views/Blog/Detail.vue').default);
// 异常关闭页面
// Vue.component('v-page-close', require('@/js/views/Errors/Close.vue').default);

//单纯价格组件
Vue.component('v-simplePrice',  require('@/js/components/common/simplePrice.vue').default);

//paypalBtn
Vue.component('v-paypal-btn', require('@/js/components/common/paypalBtn.vue').default);

// 面包屑
Vue.component('v-breadcrumb', require('@/js/components/Breadcrumb.vue').default);
// 售卖特点
Vue.component('v-sellFeatures', require('@/js/components/common/sellFeatures.vue').default);


Vue.prototype.bus = new Vue();

// 引入公用方法挂入vue
import METHODS from './methods';
for (const key in METHODS) {
  if (METHODS.hasOwnProperty(key)) {
    Vue.prototype[key] = METHODS[key]
  }
  if (key == 'send_fb_event') {
    //默认像素事件
    METHODS[key]('PageView', {})
  }
}

// 引入Sentey
import googleAnalysis from './lib/ga';

if (process.env.MIX_SENTRY_DSN && process.env.MIX_VERSION) {
  import(/* webpackChunkName: "sentry" */ `@/sentry/index`)
}

// 保存配置到全局状态
const {commit} = store

commit({
  type: 'settings/save',
  payload: {
    defaultNoImage: defaultImage
  }
})

// 谷歌分析插件
if (window.onGoogleAnalysisLoad) {
  const googleAnalysisLoad = (trackId, Ecommerce) => {
    // 保存ga信息
    commit({
      type: 'googleAnalysis/save',
      payload: {
        enable: !!trackId,
        trackId: trackId,
        ecommerce: !!parseInt(Ecommerce || 0, 2),
      }
    })
  }

  window.onGoogleAnalysisLoad(googleAnalysisLoad)

  delete window.onGoogleAnalysisLoad

  // 默认追踪页面
  googleAnalysis.page()
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
  el: '#app',
  store,
  i18n
});
